
// contacts and previousEducations need to be grouped by type (or some other key)
const infoReducer = (typeKey) => (data) => data.reduce(
  (acc, val) => {
      if (Object.prototype.hasOwnProperty.call(acc, val[typeKey])) {
          acc[val[typeKey]] = [...acc[val[typeKey]], val];
          return acc;
      }
      acc[val[typeKey]] = [val];
      return acc;
  }, {});

export const contactReducer = infoReducer('type');
export const previousEducationReducer = infoReducer('educationLevel');


export default { contactReducer, previousEducationReducer };



// WEBPACK FOOTER //
// ./src/views/StudentPersonalInfo/util.js